import { Component } from 'react'
import * as trim from 'lodash/trim'
import { Field, reduxForm } from 'redux-form'
import * as styles from 'styles/molecules/forms/Form.css'
import schema from 'schemas/loginFormSchema'
import { FORM_LOGIN } from 'constants/forms'
import { asyncValidator } from 'helpers/schemaHelpers'
import { shouldAsyncValidate, getSaveButtonFormProps, onFormSubmit } from 'helpers/formHelpers'
import { ReduxFormProps } from 'interfaces/component'
import Button from 'components/features/pfm/Button/Button'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'

type LoginFormProps = ReduxFormProps

@reduxForm({
  form: FORM_LOGIN,
  onSubmit: onFormSubmit,
  asyncValidate: asyncValidator(schema),
  shouldAsyncValidate,
  // this is needed because `email` field is being propagated to `FORM_PASSWORD_RESET` form
  destroyOnUnmount: false,
})
class LoginForm extends Component<LoginFormProps> {
  render () {
    const { handleSubmit } = this.props

    return (
      <form className={ styles.formFullWidth } onSubmit={ handleSubmit }>
        <ul>
          <li className={ styles.item }>
            <Field
              name='email'
              component={ TextFieldWrapped }
              normalize={ trim }
              props={{
                autoFocus: true,
                autoComplete: 'on',
                label: 'E-mail Address',
                type: 'text',
              }}
            />
          </li>
          <li className={ styles.item }>
            <Field name='password' props={{ label: 'Password', type: 'password', autoComplete: 'on' }} component={ TextFieldWrapped } />
            <NavigationLink to='password-reset' className={ styles.forgotPassword }>Reset Password</NavigationLink>
          </li>
          <li className={ styles.submitItem }>
            <Button { ...getSaveButtonFormProps(this.props) } submit fullWidth>
              Login
            </Button>
          </li>
        </ul>
      </form>
    )
  }
}

export default LoginForm
